<template>
    <div id="contract_billing_method_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
            
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="contractBillingMethodHeader" v-if="$route.params.id > 0">Update Contract Billing Method</span>
                        <span id="contractBillingMethodHeader" v-else>Add Contract Billing Method</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackContractBillingMethodList" >
                               <i class="hi-icon icon-flback"> </i> Back
                        </button>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ContractBillingMethodForm">
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="form-group">
                                                <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                                    <label class="control-label required" for="code">Code:</label>
                                                    <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                                    <div class="c-error">{{code_error_msg}}</div>
                                                </div>
                                            
                                                <div class="col-sm-6">
                                                <label class="control-label required" for="name">Name:</label>
                                                    <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                                    <div class="c-error">{{name_error_msg}}</div>
                                                </div>

                                                <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong id="errorMsg" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="form-group"> -->
                                    <div class="col-sm-12 btm-action-btn-fl">
                                        <div class="row">

                                            <button type="submit" id="createContractBillingMethodBtn" v-if="$route.params.id > 0" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateContractBillingMethod" >
                                            <i class="hi-icon icon-flUpdate-data"> </i>  Update
                                            </button>

                                            <button type="submit" id="createContractBillingMethodBtn" v-else class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateContractBillingMethod" >
                                            <i class="hi-icon icon-flSave"> </i>  Save
                                            </button>
                                            
                                            <button type="submit" id="createAndContinueContractBillingMethodBtn" v-if="$route.params.id == undefined" class="btn btn-primary nextBtn btn-lg pull-left save-continue-btn" v-on:click.prevent="CreateContractBillingMethod(flag='Save and Continue')" >
                                            <i class="hi-icon icon-flSave-Continue"> </i>  Save and Continue
                                            </button>

                                            <button type="submit" id="cancelContractBillingMethodBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click.prevent="BackContractBillingMethodList" >
                                            <i class="hi-icon icon-flCancel"> </i>  Cancel
                                            </button>
                                        
                                        </div>
                                    </div>
                                    <!-- </div> -->

                                </form>
                            </div>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "ContractBillingMethodCreate",
  
  mixins:[commonMixins],
  metaInfo() {
        return {title: (this.$route.params.id > 0)? "Update Contract Billing Method | " +process.env.COPYRIGHT_NAME : "Create Contract Billing Method | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    name: "",
    loading:false,
    code_error_msg: "",
    name_error_msg: ""
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_contract_billing_method') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        
        if (segments[3]) {
            self.loadContractBillingMethod();
        }
  },
  methods: {

    BackContractBillingMethodList() {
      var self = this;
      self.$router.push("/contractbillingmethod/list");
    },

    CreateContractBillingMethod(flag) {
        var self = this;

        self.code = self.code.trim();
        self.name = self.name.trim();

        self.code_error_msg = "";
        self.name_error_msg = "";

        if (!self.code || self.code == null || self.code == "") {
            self.code_error_msg = "Code Required.";
        }

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name Required.";
        }

        if (self.code_error_msg == "" && self.name_error_msg == "") {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createContractBillingMethodBtn").val("Updating ...");
                $("#createContractBillingMethodBtn").prop("disabled", true);
                $("#cancelContractBillingMethodBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueContractBillingMethodBtn").val("Saving ...");
                    $("#createContractBillingMethodBtn").prop("disabled", true);
                    $("#createAndContinueContractBillingMethodBtn").prop("disabled", true);
                    $("#cancelContractBillingMethodBtn").prop("disabled",true);

                }else{

                    $("#createContractBillingMethodBtn").val("Saving ...");
                    $("#createContractBillingMethodBtn").prop("disabled", true);
                    $("#createAndContinueContractBillingMethodBtn").prop("disabled", true);
                    $("#cancelContractBillingMethodBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/contractbillingmethod/create",
                type: "POST",
                data: {code: self.code,id: segments[3], name: self.name},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createContractBillingMethodBtn").val("Update");
                        $("#createContractBillingMethodBtn").prop("disabled", false);
                        $("#cancelContractBillingMethodBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueContractBillingMethodBtn").val("Save and Continue");
                            $("#createContractBillingMethodBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingMethodBtn").prop("disabled", false);
                            $("#cancelContractBillingMethodBtn").prop("disabled",false);

                        }else{

                            $("#createContractBillingMethodBtn").val("Save");
                            $("#createContractBillingMethodBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingMethodBtn").prop("disabled", false);
                            $("#cancelContractBillingMethodBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.code = "";
                            self.name = "";

                        }else{
                            self.$router.push("/contractbillingmethod/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createContractBillingMethodBtn").val("Update");
                        $("#createContractBillingMethodBtn").prop("disabled", false);
                        $("#cancelContractBillingMethodBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {
                            
                            $("#createAndContinueContractBillingMethodBtn").val("Save and Continue");
                            $("#createContractBillingMethodBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingMethodBtn").prop("disabled", false);
                            $("#cancelContractBillingMethodBtn").prop("disabled",false);

                        }else{

                            $("#createContractBillingMethodBtn").val("Save");
                            $("#createContractBillingMethodBtn").prop("disabled", false);
                            $("#createAndContinueContractBillingMethodBtn").prop("disabled", false);
                            $("#cancelContractBillingMethodBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'contract-billing-method-create')
                }
            });
        }
    },

    loadContractBillingMethod() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/contractbillingmethod/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.code = data.content.code;
                    self.name = data.content.name;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'get-contract-billing-method-by-id')
            }
        });
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/ContractBillingMethodCreate.vue